import { observer } from "mobx-react";
import {useServices} from "../../../../react-hooks/use-services.hook";
import React, {useEffect, useRef, useState} from "react";
import {
    SoundIconContainer
} from "./sound-icon/video-slides-sound.box";
import {VideoSlidesSoundIconPositioningBox} from "./sound-icon/video-slides-sound-icon-positioning.box";
interface VideoSlidesSoundIconComponentProps {
    containerRef: React.MutableRefObject<any>;
}

export const VideoSlidesSoundIconComponent: React.FC<VideoSlidesSoundIconComponentProps> = observer((props) => {
    const services = useServices();
    const liveStreamPlaying = services.liveStreamPlaying;

    const [displaySoundIcon, setDisplaySoundIcon] = useState(false);

    const SoundOnIcon = services.theme.currentTheme.icons.soundOnIcon;
    const SoundOffIcon = services.theme.currentTheme.icons.soundOffIcon;

    let timeOutRef = useRef(null);


    useEffect(() => {
        const handleClick = () => {
            if (timeOutRef.current) {
                clearTimeout(timeOutRef.current);
            }
            liveStreamPlaying.toggleVideoSound();

            setDisplaySoundIcon(true);

            timeOutRef.current = setTimeout(() => {
                    setDisplaySoundIcon(false);
                }, 2000); // Adjust the delay as needed
        };

        const containerElement = props.containerRef.current;
        if (containerElement) {
            containerElement.addEventListener('click', handleClick);
        }

        return () => {
            if (containerElement) {
                containerElement.removeEventListener('click', handleClick);
            }
        };
    }, [props.containerRef, liveStreamPlaying]);

    return (
        <>
            {displaySoundIcon && (
                <VideoSlidesSoundIconPositioningBox>
                    <SoundIconContainer>
                        {liveStreamPlaying.isVideoMuted ? <SoundOffIcon size={3.5} /> : <SoundOnIcon size={3}/>}
                    </SoundIconContainer>
                </VideoSlidesSoundIconPositioningBox>
            )}
        </>
    )
});
